import React, { useState,useEffect } from "react";
// import IP from "../../../images/IP_Image.png"
import IP from "../../../images/peck2.jpg";
import ph_logo from "../../../images/IFFFI_LOGO.png";
import ph_Nfdc from "../../../images/NFDC-Logo.png";
// import TajMahal from "../../images/TajMahal.png"
import TajMahal from "../../../images/Group 706.png";
import "./registernow.css";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import EmailIcon from "@mui/icons-material/Email";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { postRequest } from "../../../API/IP";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import pecock_vdo from "../../../images/peco.gif";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import { postRequestGlobal } from "../../../API/global";
import ReCAPTCHA from "react-google-recaptcha";
import { CAPTCHA_KEY_CLIENT_SIDE } from "../../../API/global";

const RegisterNow = () => {
  const { param = "indian-paranoma" } = useParams(); 
    const navigate = useNavigate();

  useEffect(()=>{
    if(!(param == "indian-panorama" || param == "web-series" || param=="creative-mind-tomorrow" )){
      navigate("/indian-panorama");
    }
  },[param])
  localStorage.setItem("param", param);
  // const data_check = localStorage.getItem('param');
  //console.log({ data_check });

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [captchaValue, setCaptchaValue] = useState(null);

  const handleClickShowPasswordOne = () => setShowPasswordOne((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // console.log(formData)

  const [errors, setErrors] = useState({});


  // const validateValues = (inputValues) => {
  //     let errors = {};
  //     if (inputValues.email.length < 10) {
  //         errors.email = "Email is too short";
  //     }
  //     if (inputValues.password.length < 5) {
  //         errors.password = "Password is too short";
  //     }
  //     return errors;
  // };

  const validateValues = (inputValues) => {
    let errors = {};
    if (!inputValues.username || inputValues.username.length < 10) {
      errors.username = "Email is too short";
    }
    if (!inputValues.password || inputValues.password.length < 5) {
      errors.password = "Password is too short";
    }
    return errors;
  };

  // console.log(formData, "formData")

  const handleInputChange = async (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });

    if (name === "username") {
      await handleEmailVerify(value);
    }
  };

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateValues(formData);
    setErrors(formErrors);
    // setOpen(true);
    // setAlertOpen(true)
    // setAlertMessage('Login successfully');
    // setAlertSeverity('success');

    if (!captchaValue) {
      setAlertMessage("Please complete the CAPTCHA");
      setAlertSeverity("error");
      setAlertOpen(true);
      return;
    }

    const emailErrorMsg = await handleEmailVerify(formData.username);
    // console.log({ emailErrorMsg });
    if (!emailErrorMsg) {
      return;
    }

    // Check if there are any errors
    if (Object.keys(formErrors).length > 0) {
      // There are validation errors, do not submit the form
      return;
    }
    setLoading(true);
    try {
      const payload = {
        ...formData,
        captcha: captchaValue,
      };
      const response = await postRequest("login", payload);

      // console.log('amar test', response)
      // Reset form after successful login
      setFormData({
        username: "",
        password: "",
      });

      // const token = response.data.access_token;
      const message = response.message;

      if (response.status === true) {
        setAlertSeverity("success"); // set green color for success
      } else {
        setAlertSeverity("error"); // set red color for error
      }

      setAlertMessage(message);

      const token = response.authorization.access_token;

      localStorage.setItem("token", token);
      setAlertMessage("Login successfully");
      setAlertSeverity("success");
      setAlertOpen(true);
      // navigate('/dashboard');
      setTimeout(() => {
        const festival_name = localStorage.getItem("param");
        if (festival_name === "web-series") {
          navigate("/dashboard/ott");
        } else if (festival_name === "creative-mind-tomorrow") {
          navigate("/dashboard/cmot");
        } 
        // else if (festival_name === "indian-debut-director") {
        //   navigate("/dashboard/dd");
        // } 
        else {
          navigate("/dashboard/ip");
        }

        setLoading(false);
      }, 1000);
      // alert('Login successfully');
    } catch (error) {
      console.error("Error: ", error);
      // setErrors('Invalid username or password. Please try again.');
      // setAlertMessage('Invalid username or password. Please try again.');
      setAlertSeverity("error");
      setAlertOpen(true);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 800);
    }
  };

  const handleEmailVerify = async (value) => {
    let flag = true;

    let emailErrorMsg = "";
    if (!value.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)) {
      flag = false;
      emailErrorMsg = "Invalid email format";
    } else {
      try {
        const payload = { email: value };

        const response = await postRequestGlobal("verify-email", payload);
        if (response.data === 0) {
          flag = false;
          emailErrorMsg = "Email ID does not exist";
        }
      } catch (error) {
        console.error("Error verifying email:", error);
      }
    }
    setEmailError(emailErrorMsg);
    // console.log({flag});

    return flag;
  };

  // const handleClose = ( reason) => {
  //     if (reason === 'clickaway') {
  //       return;
  //     }
  //     setOpen(false);
  //   };

  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  return (
    <>
      {loading && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          // bgcolor="#1c57687d"
          bgcolor="#1c682c7d"
          zIndex={1000}
        >
          <img src={pecock_vdo} alt="Loading..." />
          {/* <CircularProgress /> */}
        </Box>
      )}

      <div className="container-fluid px-0 w-100 overflow-x-hidden position-absolute">
        <div className="row h-100">
          <div className="col-sm-12 col-md-12 col-lg-6 overflow-x-hidden h-100 response-phone">
            <img
              src={IP}
              className="mob-IP"
              alt="Indian Panorama"
              width="100%"
              height="100%"
            />
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-6 second-box h-100 overflow-auto">
            <div className="new-div">
              <div className="logo-Phone">
                <a href={process.env.REACT_APP_HOME_URL}>
                  <img
                    src={ph_logo}
                    className=""
                    alt="Indian Panorama"
                    width="85px"
                    height="auto"
                  />
                </a>
                <img
                  src={ph_Nfdc}
                  className=""
                  alt="Indian Panorama"
                  width="85px"
                  height="auto"
                />
              </div>
              {/* <p className='register me-3'>Don't have account ? &nbsp;&nbsp; */}
              {/* </p><p>  */}
              {/* <Link to="/registration" className='log_in_now'> Register Now</Link></p> */}
              <div className="container">
                <div className="row">
                  <div className="col-md-0 col-lg-2"></div>
                  <div className="col-md-12 col-lg-8">
                    <h1 className="welcome">Welcome</h1>
                    {/* <p className='login_with_email'>Login with Email</p> */}
                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                      <div className="input_field">
                        <TextField
                          variant="outlined"
                          fullWidth
                          type="email"
                          placeholder="Email ID"
                          iconstart={<EmailIcon />}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <EmailIcon />
                              </InputAdornment>
                            ),
                            style: {
                              border: "1px solid #1c5768",
                              borderRadius: "5px",
                            },
                          }}
                          className="input_border"
                          name="username"
                          value={formData.username}
                          onChange={handleInputChange}
                        />
                        {emailError && (
                          <p className="error text-danger">{emailError}</p>
                        )}
                      </div>

                      <div>
                        <TextField
                          variant="outlined"
                          fullWidth
                          // type='password'
                          placeholder="*************"
                          // iconstart={<LockOutlinedIcon />}
                          // InputProps={{
                          //     startAdornment: (
                          //         <InputAdornment position="start">
                          //             <LockOutlinedIcon />
                          //         </InputAdornment>
                          //     ),
                          //     style: { border: '1px solid #1c5768', borderRadius: '5px' }
                          // }}
                          // InputProps={{
                          //     endAdornment: (
                          //       <InputAdornment position="start">
                          //         <IconButton
                          //           aria-label="toggle password visibility"
                          //           onClick={handleClickShowPasswordOne}
                          //           onMouseDown={handleMouseDownPassword}
                          //           edge="end"
                          //         >
                          //           {showPasswordOne ? <VisibilityOff /> : <Visibility />}
                          //         </IconButton>
                          //       </InputAdornment>
                          //     ),
                          //     style: {
                          //       border: "1px solid #1c5768",
                          //       borderRadius: "5px",
                          //     },
                          //   }}
                          //   InputProps={{
                          //     startAdornment: (
                          //         <InputAdornment position="start">
                          //             <IconButton
                          //                 aria-label="toggle password visibility"
                          //                 onClick={handleClickShowPasswordOne}
                          //                 onMouseDown={handleMouseDownPassword}
                          //                 edge="start"
                          //             >
                          //                 {showPasswordOne ? <VisibilityOff /> : <Visibility />}
                          //             </IconButton>
                          //         </InputAdornment>
                          //     ),
                          //     style: {
                          //         border: "1px solid #1c5768",
                          //         borderRadius: "5px",
                          //     },
                          // }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LockOutlinedIcon />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPasswordOne}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPasswordOne ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                            style: {
                              border: "1px solid #1c5768",
                              borderRadius: "5px",
                            },
                          }}
                          type={showPasswordOne ? "text" : "password"}
                          name="password"
                          value={formData.password}
                          onChange={handleInputChange}
                        />
                        {errors.password ? (
                          <p className="error text-danger">
                            Please enter valid password
                          </p>
                        ) : null}
                      </div>
                      <p className="forget_password">
                        <Link to="/forget-password" className="register_now">
                          Forget your password?
                        </Link>
                      </p>

                      <div className="m-3">
                        <ReCAPTCHA
                          sitekey={CAPTCHA_KEY_CLIENT_SIDE}
                          onChange={handleCaptchaChange}
                        />
                      </div>

                      <div className="button">
                        <button className="login">Log in</button>
                      </div>
                      {/* {error && <p className="error">{error}</p>} */}
                    </form>
                    <p className="text-center mt-3">
                      Don't have account ? &nbsp;&nbsp;
                    </p>
                    <p className="text-center mt-3">
                      <Link to="/registration" className="log_in_now">
                        {" "}
                        Register Now
                      </Link>
                    </p>
                  </div>
                  <div className="col-md-0 col-lg-2"></div>
                </div>
              </div>
              <div className="taj-imag">
                <img
                  src={TajMahal}
                  className="tajmahal"
                  alt="Tajmal image"
                  width="100%"
                  height="100%"
                />
              </div>
            </div>

            {/* <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert
                  onClose={handleClose}
                  severity="success"
                  variant="filled"
                  sx={{ width: '100%' }}
                >
                  Login successfully
                </Alert>
              </Snackbar> */}
            {/* <Snackbar open={alertOpen} autoHideDuration={6000} onClose={handleAlertClose}>
                                <Alert onClose={handleAlertClose} severity={alertSeverity} sx={{ width: '100%' }}>
                                    {alertMessage}
                                </Alert>
                            </Snackbar> */}
            <Snackbar
              open={alertOpen}
              autoHideDuration={6000}
              onClose={() => setAlertOpen(false)}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert
                onClose={() => setAlertOpen(false)}
                severity={alertSeverity}
                variant="filled"
              >
                {alertMessage}
              </Alert>
            </Snackbar>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterNow;
